import { ACTIONS } from './connectionUtils'

interface product {
  id?: number
  name: string
  shop: string
  ingredient: number
  storable: number
  pack: number
}

interface ProductResponse {
  success: boolean
  products?: product[]
  error?: string
}

async function getProductList(user: string): Promise<ProductResponse> {
  try {
    const response = await fetch('/api/product', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.GET,
        user,
      }),
    })
    const data: ProductResponse = await response.json()
    return data
  } catch (error) {
    console.error('Product error:', error)
    throw error
  }
}

async function insertProduct(user: string, product: product) {
  try {
    const response = await fetch('/api/product', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.INSERT,
        user,
        product,
      }),
    })
    return await response.json()
  } catch (error) {
    console.error('Product error:', error)
    throw error
  }
}

async function updateProduct(user: string, product: product) {
  try {
    const response = await fetch('/api/product', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.UPDATE,
        user,
        product,
      }),
    })
    return await response.json()
  } catch (error) {
    console.error('Product error:', error)
    throw error
  }
}

async function deleteProduct(user: string, id: number) {
  try {
    const response = await fetch('/api/product', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.DELETE,
        user,
        id,
      }),
    })
    return await response.json()
  } catch (error) {
    console.error('Product error:', error)
    throw error
  }
}

const productChanged = (originalProduct: product, newProduct: product) => {
  return (
    originalProduct.name !== newProduct.name ||
    originalProduct.shop !== newProduct.shop ||
    originalProduct.ingredient !== newProduct.ingredient ||
    originalProduct.storable !== newProduct.storable ||
    originalProduct.pack !== newProduct.pack
  )
}

export {
  getProductList,
  insertProduct,
  updateProduct,
  deleteProduct,
  productChanged,
}

export type { product }
